<div class="survey-skeleton" role="status" aria-live="polite" aria-busy="true">
  @if (title) {
    <h1
      class="font-normal text-[2.5rem] title-dynamic-theme mb-6"
      [innerHTML]="title"
    ></h1>
  }
  <span class="sr-only" aria-hidden="false"
    >Survey content is loading. Please wait.</span
  >

  <div class="skeleton-line skeleton-title" aria-hidden="true"></div>
  <div class="skeleton-line skeleton-subtitle" aria-hidden="true"></div>

  <div class="skeleton-block" aria-hidden="true">
    <div class="skeleton-line"></div>
    <div class="skeleton-input"></div>
  </div>

  <div class="skeleton-block" aria-hidden="true">
    <div class="skeleton-line"></div>
    <div class="skeleton-input"></div>
  </div>

  <div class="skeleton-block" aria-hidden="true">
    <div class="skeleton-line"></div>
    <div class="skeleton-input"></div>
    <div class="skeleton-input short"></div>
  </div>
</div>
